export default function AppSection() {
  return (
    <section id="app" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="bg-gradient-to-br from-background-200/80 via-background-200/50 to-primary-500/5 rounded-2xl overflow-hidden">
          <div className="flex flex-col lg:flex-row items-center gap-8 p-8 md:p-12 lg:p-16">
            <div className="flex-1 text-center lg:text-left">
              <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-500/10 border border-primary-500/20 mb-4">
                <span className="text-xs text-primary-400 whitespace-nowrap">随时随地看</span>
              </div>
              <h2 className="font-heading text-2xl md:text-4xl text-foreground-50 mb-4">
                69视频移动端
              </h2>
              <p className="text-sm md:text-base text-foreground-300 leading-relaxed mb-6 max-w-lg mx-auto lg:mx-0">
                下载69视频移动客户端，随时随地观看西瓜视频免费、91在线视频等海量影视内容。支持离线缓存、画质切换、投屏播放等功能，让追剧更加自由便捷。
              </p>
              <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4">
                <div className="flex items-center gap-3 px-5 py-3 bg-background-300/60 rounded-xl cursor-pointer hover:bg-background-300 transition-colors">
                  <i className="ri-android-line text-2xl text-accent-400 w-6 h-6 flex items-center justify-center"></i>
                  <div className="text-left">
                    <div className="text-xs text-foreground-400">Android 版</div>
                    <div className="text-sm font-medium text-foreground-200 whitespace-nowrap">下载 APK</div>
                  </div>
                </div>
                <div className="flex items-center gap-3 px-5 py-3 bg-background-300/60 rounded-xl cursor-pointer hover:bg-background-300 transition-colors">
                  <i className="ri-apple-line text-2xl text-accent-400 w-6 h-6 flex items-center justify-center"></i>
                  <div className="text-left">
                    <div className="text-xs text-foreground-400">iOS 版</div>
                    <div className="text-sm font-medium text-foreground-200 whitespace-nowrap">App Store</div>
                  </div>
                </div>
              </div>
            </div>
            <div className="flex-shrink-0">
              <div className="relative w-[240px] h-[480px] rounded-[2rem] overflow-hidden border-4 border-background-300 bg-background-200">
                <img
                  src="https://readdy.ai/api/search-image?query=Smartphone%20mockup%20displaying%20video%20streaming%20app%20interface%20with%20movie%20thumbnails%20and%20play%20button%2C%20dark%20theme%20UI%20with%20warm%20orange%20accents%2C%20modern%20mobile%20design%2C%20clean%20layout%20with%20cinematic%20posters%2C%20premium%20app%20aesthetic&width=480&height=960&seq=app-mockup-03&orientation=portrait"
                  alt="69视频移动端界面"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}